module.exports = __webpack_public_path__ + "img/phoneTitle.94c056d7.png";